{
  "Accessibility menu": "ප්‍රවේශනීය මෙනුව",
  "Reset settings": "සැකසුම් යළි පිහිටුවන්න",
  "Close": "වසන්න",
  "Content adjustments": "අන්තර්ගත සකස්කිරීම්",
  "Navigation adjustments": "යාත්‍රණ සකස්කිරීම්",
  "Align Left": "වමට සමපාත කරන්න",
  "Adjust Font Size": "අකුරු ප්‍රමාණය සකස් කරන්න",
  "Highlight Title": "ශීර්ෂය උද්දීපනය කරන්න",
  "Highlight Links": "සබැඳි උද්දීපනය කරන්න",
  "Readable Font": "කියවිය හැකි අකුරු",
  "Colour adjustments": "වර්ණ සකස්කිරීම්",
  "Dark Contrast": "අඳුරු විරෝධීතාවය",
  "Light Contrast": "බැබළෙන විරෝධීතාවය",
  "High Contrast": "ඉහළ විරෝධීතාවය",
  "High Saturation": "ඉහළ සංතෘප්තතාවය",
  "Low Saturation": "අඩු සංතෘප්තතාවය",
  "Monochrome": "ඒකවර්ණ",
  "Tools": "මෙවලම්",
  "Reading Guide": "කියවීමේ මාර්ගෝපදේශකය",
  "Stop Animations": "සජීවිකරණ නවත්වන්න",
  "Big Cursor": "විශාල කර්සරය",
  "Increase Font Size": "අකුරු ප්‍රමාණය වැඩි කරන්න",
  "Decrease Font Size": "අකුරු ප්‍රමාණය අඩු කරන්න",
  "Letter Spacing": "අකුරු අතර අවකාශය",
  "Line Height": "පේළි උස",
  "Font Weight": "අකුරු බර",
  "Dyslexia Font": "ඩිස්ලෙක්සියා අකුරු",
  "Language": "භාෂාව",
  "Accessibility widget": "ප්‍රවේශනීය මෙනුව විවෘත කරන්න",
  "Accessibility Profiles": "ප්‍රවේශනීය පැතිකඩ",
  "Cognitive Disability": "ඥානාත්මක ආබාධය",
  "Seizure Safe": "ආක්‍රමණික ආරක්ෂිත",
  "Accessibility statement": "ප්‍රවේශනීය ප්‍රකාශනය"
}